import { useAiReceptionistStateSuppress } from './use-ai-receptionist-state-suppress';
import { useAutoPauseSmsWithReminder } from './use-auto-pause-sms-with-reminder';

export const useAutoPauseReminderPreferences = () => {
  useAutoPauseSmsWithReminder();
  useAiReceptionistStateSuppress();
};
